
/**
 * Truncates the provided text given the truncateLength and truncateAllowance.
 * If the text does not need to be truncated, null string is returned
 * TODO: does this work for Chinese? Do we bother with Arabic?
 *
 * @param text - text to truncate (should already be trimmed, otherwise spaces count)
 * @param truncateLength - how long the truncated text should be
 * @param truncateAllowance - allows the text to go over a little without truncation. Helps avoid
 *                            a case where the expanded text is only a few more characters.
 */
export function truncateText(text, truncateLength, truncateAllowance = 0) {
  const shouldTruncate = text && text.length > (truncateLength + truncateAllowance)
  if (shouldTruncate) {
    // doing +1 to determine if last character is the end of a word or not
    const truncatedTextPlus1 = text.substring(0, truncateLength + 1)
    const lastSpaceIndex = truncatedTextPlus1.lastIndexOf(' ')
    if (lastSpaceIndex < 0) {
      // need to do a hard truncate because there is no space
      return text.substring(0, truncateLength + truncateAllowance)
    }
    if (lastSpaceIndex === truncatedTextPlus1.length - 1) {
      // last character is a space, just trim
      return truncatedTextPlus1.trim()
    }
    return text.substring(0, lastSpaceIndex).trim()
  }
  return null
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/util/text-utils.ts